export default __webpack_public_path__ + "static/media/unlock.de4cec12.svg";